// extracted by mini-css-extract-plugin
export default {"header":"create_header__5qtCv","header_text":"create_header_text__9A4N+","buttons":"create_buttons__T80-7","spinner":"create_spinner__r6p+P"};